<!-- Added automation IDs 19/10/2026 DW -->
@if (item.navCap) {
  <div mat-subheader class="nav-caption">
    {{ item.navCap }}
  </div>
}
@if (!item.navCap && !item.external && !item.twoLines) {
  @if (item.route && (!item.children || !item.children.length)) {
    <a
      [id]="navItemAutomationId()"
      class="menu-list-item"
      [routerLink]="item.route"
      routerLinkActive="activeMenu"
      [routerLinkActiveOptions]="{ exact: false }"
      [queryParamsHandling]="'preserve'"
      [class.disabled]="item.disabled"
      (click)="onItemSelected(item)"
    >
      <i-tabler name="{{ item.iconName }}" class="routeIcon"></i-tabler>
      <span class="hide-menu">{{ item.displayName | translate }}</span>
      @if (item.chip) {
        <span>
          <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{
            item.chipContent
          }}</span>
        </span>
      }
    </a>
  } @else {
    <button
      type="button"
      [id]="navItemAutomationId()"
      class="menu-list-item"
      [class.expanded]="expanded"
      [class.disabled]="item.disabled"
      (click)="onItemSelected(item)"
    >
      <i-tabler name="{{ item.iconName }}" class="routeIcon"></i-tabler>
      <span class="hide-menu">{{ item.displayName | translate }}</span>
      @if (item.children && item.children.length) {
        <span class="arrow-icon" fxFlex>
          <span fxFlex></span>
          <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
            expand_more
          </mat-icon>
        </span>
      }
      @if (item.chip) {
        <span>
          <span class="{{ item.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{
            item.chipContent
          }}</span>
        </span>
      }
    </button>
  }
}
@if (!item.navCap && item.external) {
  <a
    [id]="navItemAutomationId('external')"
    class="menu-list-item"
    href="//google.com"
    target="_blank"
    rel="noopener"
  >
    <i-tabler class="routeIcon" name="{{ item.iconName }}"></i-tabler>
    <span class="hide-menu">{{ item.displayName | translate }}</span>
  </a>
}
@if (expanded) {
  <div>
    @for (child of item.children; track child) {
      <app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth + 1">
      </app-nav-item>
    }
  </div>
}
